import { fabric } from 'fabric_gesture';

export class Segment {
    start: Point;
    end: Point;

    constructor(a: Point, b: Point) {
        this.start = a;
        this.end = b;
    }
}

export class ClosestSegment extends Segment {
    distance: number;

    constructor(a: Point, b: Point, distance: number) {
        super(a, b);
        this.distance = distance;
    }
}

export interface Point {
    x: number;
    y: number;
}

// TODO: Collision-proof uids generated
export class iPolygon extends fabric.Polygon {
    public readonly uid: number;
    public points: Array<iPoint>;

    constructor(points: Array<any>, opts: any) {
        super(points, opts);
        this.uid = Math.floor(Math.random() * Math.floor(10000000));
    }
}

// TODO: Collision-proof uids generated
export class iPoint extends fabric.Point {
    public readonly uid: number;
    public x: number;
    public y: number;

    constructor(x: number, y: number) {
        super(x, y);
        this.uid = Math.floor(Math.random() * Math.floor(10000000));
    }
}


// WEBPACK FOOTER //
// ./src/app/model/geometry.ts